import { Empty } from "antd"
import React from "react"

interface PortalEmptyStateProps {
  title: React.ReactNode
  description?: React.ReactNode
  action?: React.ReactNode
  compact?: boolean
}

/** One consistent empty-state look across the portal — a title, an optional
 * one-line explanation, and an optional action. `compact` trims the
 * vertical padding for a state that sits inside an already-bordered card
 * (e.g. "You're all caught up") rather than filling a whole page. */
export function PortalEmptyState({ title, description, action, compact }: PortalEmptyStateProps) {
  if (compact) {
    return (
      <div className="flex flex-col items-start gap-1 py-1">
        <p className="text-sm text-gray-500">{title}</p>
        {description && <p className="text-sm text-gray-400">{description}</p>}
        {action}
      </div>
    )
  }

  return (
    <Empty
      description={
        <div>
          <p className="font-medium text-gray-700">{title}</p>
          {description && <p className="text-sm text-gray-500">{description}</p>}
        </div>
      }
    >
      {action}
    </Empty>
  )
}
